import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setSessionStorageItems } from '../../../authComponents/login/LoginApiResponse';
import FullPageLoader from '../../../loaders/FullPageLoader';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { parseJwt } from '../../../helper/genericFunction';
import { dispatchHandler } from '../../../helper/apiHelperFunctions';
import { deleteDB } from 'idb';
import { useContext } from 'react';
import { UserDetailsContext } from '../../../App';
import { getDataStorageKey, getMenuMode } from '../../../helper/helperTableFunctions';

const SwitchEntResponseHandler = (props) => {
    const tokenData = parseJwt(sessionStorage.getItem("token") || "") || {};
    const [loading, setLoading] = useState(false)
    const authStore = useSelector(state => state.authStore);
    const location = useLocation()
    const history = useHistory();
    const dispatch = useDispatch();
    const userDetailsContext = useContext(UserDetailsContext)

    useEffect(() => {
        if (authStore?.["updateOrgIdData"]?.isSuccess) {
            let data = authStore?.["updateOrgIdData"]?.data || {};
            dispatchHandler(dispatch, "switchEntRequest", {
                "orgId": data?.orgId || "",
                "entId": data?.entId || "",
                "uCode": data?.ucode ,
                "token": sessionStorage?.getItem("token") || ""
            })
        }
    }, [authStore?.["updateOrgIdData"]?.isSuccess])

    useEffect(() => {
        if(authStore?.["switchEntData"]?.isLoading){ setLoading(true);}

        if(authStore?.["switchEntData"]?.isError){ setLoading(false);}
        
        if (authStore?.["switchEntData"]?.isSuccess) {
            let data = authStore?.["switchEntData"]?.data?.resource || {};
            setTimeout(() => {
                setData(data);
            }, 0)
        }
    }, [authStore?.["switchEntData"]])

    const setData = async (data) => {
        let currentDbKey = getDataStorageKey?.();
        if (currentDbKey) await deleteDB(currentDbKey);
        let newTokenData = parseJwt(data?.token);
        let newDbKey = `Supplymint-ai-local-storage-${newTokenData?.jti || ""}`;
        if (newDbKey && newDbKey !== currentDbKey) await deleteDB(newDbKey);

        sessionStorage.setItem("switchOrgResponse", JSON.stringify(data));
        await setSessionStorageItems(data, {
            ...userDetailsContext,
            updateContext: false,
        });
        handleReRouting(data);
    }

    // Function : To reroute the data on organisation change
    const handleReRouting = (data) => {
        let dashboardPaths = data?.dashboardModules?.map(item => item?.pageUrl);

        let newPath = dashboardPaths?.[0];
        history.replace(newPath ? newPath?.replace("#", "") :  getMenuMode?.() == "new" ? "/app" : "/home");
        setTimeout(() => {
            window.location?.reload();
        }, 0)
    }


    return (
        <React.Fragment>
            {/* Set Loading to true and show the full page loader */}
            {loading && <div style={{ position: "absolute", width: "100vw", height: "100vh", position: "fixed", zIndex: 999}}>
                {/* Render the full page loader for the switch organisation */}
                <FullPageLoader type = "switchOrg"/>
            </div>}
        </React.Fragment>
    )
}

export default SwitchEntResponseHandler